import { render, staticRenderFns } from "./AveineQuizReminderSettings.vue?vue&type=template&id=67838544"
import script from "./AveineQuizReminderSettings.vue?vue&type=script&lang=js"
export * from "./AveineQuizReminderSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports